module.exports = __webpack_public_path__ + "img/banner.aab6a28f.png";